import { Divider, ListItemButton, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { ts } from 'src/utils/translate';
import { PersonIcon } from 'src/icons/PersonIcon';
import { NewspaperIcon } from 'src/icons/NewspaperIcon';
import { SendIcon } from 'src/icons/SendIcon';
import { Link, useLocation } from 'react-router';

const PROFILE_PATH = '/profile';

export function UserMenu(props: { anchorEl: HTMLElement | null, handleClose: () => void }) {
  const open = Boolean(props.anchorEl);
  const location = useLocation();
  // opened again on the profile page, the Go back target stays the page the profile was opened from
  const profileBackTarget = location.pathname === PROFILE_PATH ? location.state?.from : location.pathname;
  return (
      <Menu
          id="user-menu"
          anchorEl={props.anchorEl}
          open={open}
          onClose={props.handleClose}
      >
        <MenuItem onClick={props.handleClose}>
          <ListItemButton disableGutters component={Link} to={PROFILE_PATH} state={{ from: profileBackTarget }}>
            <ListItemIcon>
              <PersonIcon/>
            </ListItemIcon>
            <ListItemText>
              {ts('edit_profile', 'Edit profile')}
            </ListItemText>
          </ListItemButton>
        </MenuItem>
        <Divider/>
        <MenuItem onClick={props.handleClose}>
          <ListItemButton disableGutters component='a' href='https://uplan.io/about' target='_blank'>
            <ListItemIcon>
              <NewspaperIcon/>
            </ListItemIcon>
            <ListItemText>
              {ts('impressum', 'Impressum')}
            </ListItemText>
          </ListItemButton>
        </MenuItem>
        <MenuItem onClick={props.handleClose}>
          <ListItemIcon>
            <SendIcon/>
          </ListItemIcon>
          <ListItemText>
            {ts('send_feedback', 'Send feedback')}
          </ListItemText>
        </MenuItem>
      </Menu>
  )
}